import { createContext } from 'react';

import type { SyncEngine, SyncState } from './sync-engine';

export interface SyncContextValue {
    state: SyncState;
    engine: SyncEngine | null;
    /**
     * Probeer nu te synchroniseren (knop "nu versturen"): slaat de backoff over en
     * breekt een ronde af die vastzit.
     */
    flushNow: () => Promise<void>;
    /** Zet geblokkeerde bewerkingen terug in de wachtrij. */
    retryFailed: () => Promise<void>;
}

export const SyncContext = createContext<SyncContextValue | null>(null);
